import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { DeleteBookmarkUseCase } from './DeleteBookmarkUseCase';
import { AddBookmarkUseCase } from './AddBookmarkUseCase';
// import { GetBookmarkDetailUseCase } from './GetBookmarkDetailUseCase';
import { GetBookmarkUseCase } from './GetBookmarkUseCase';
import { GetWatchAgainUseCase } from './GetWatchAgainUseCase';

export const initializeBookmarkUseCases = (container: Container) => {
    container.register(DI.USECASES.IAddBookmarkUseCase, {
        useClass: AddBookmarkUseCase,
    });
    container.register(DI.USECASES.IDeleteBookmarkUseCase, {
        useClass: DeleteBookmarkUseCase,
    });
    // container.register(DI.USECASES.IGetBookmarkDetailUseCase, {
    //     useClass: GetBookmarkDetailUseCase,
    // });
    container.register(DI.USECASES.IGetBookmarkUseCase, {
        useClass: GetBookmarkUseCase,
    });
    container.register(DI.USECASES.IGetWatchAgainUseCase, {
        useClass: GetWatchAgainUseCase,
    });
};
